<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size-xs="12" size-md="6" offset-md="3" size-lg="4" offset-lg="4">
        <form [formGroup]="verifyCodeForm" (ngSubmit)="verifyCode()">
          <ion-item lines="none">
            <ion-label position="stacked">{{fieldNames.code}}</ion-label>
            <ion-input 
              class="auth-input" 
              autocomplete="one-time-code" 
              type="tel" 
              formControlName="code" 
              color="input-text" 
              maxlength="8" 
              aria-placeholder="SMS Code"
              placeholder="SMS Code"
            ></ion-input>
          </ion-item>
          <!--<app-control-messages [control]="verifyCodeForm.controls.code" [fieldName]="fieldNames['code']"></app-control-messages>-->
        </form>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="showResendButton">
      <ion-col style="text-align: center;">
        Didn't receive the verification code?<br/><a href="javascript:void(0)" (click)="resendCode()">Re-send SMS.</a>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="auth-footer">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button expand="block" type="submit" class="auth-button primary" [disabled]="!verifyCodeForm.valid" (click)="verifyCode()">Verify Code</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
